/**
 * Smooth scroll functionality
 */

export function initSmoothScroll() {
    document.querySelectorAll('a[href*="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const href = this.getAttribute('href');
            
            // Skip contact links as they open popup
            if (href === '#contact') {
                return;
            }
            
            // Check if it's an external link with anchor (like /nos-expertises#something)
            if (href.includes('/') && href.includes('#')) {
                // Let the browser handle navigation to another page with anchor
                return;
            }
            
            // Only handle pure anchor links on the same page
            if (href.startsWith('#')) {
                e.preventDefault();
                const targetId = href;
                
                if (targetId !== '#') {
                    const target = document.querySelector(targetId);
                    if (target) {
                        target.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }
            }
        });
    });
}